import { useEffect, useState } from "react";

// Returns true on touch-primary devices (iPhone/Android/tablets). Updates live if the user hot-plugs
// a pointer so the UX adapts without a reload. Server-side renders fall through to false.
const QUERY = "(hover: none) and (pointer: coarse)";

export function useIsTouch() {
  const [isTouch, setIsTouch] = useState(() => typeof window !== "undefined" && window.matchMedia && window.matchMedia(QUERY).matches);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setIsTouch(e.matches);
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  return isTouch;
}
